function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

function moveZoom(image, hoverArea, event) {
  const bounds = hoverArea.getBoundingClientRect();
  const xPosition = clamp(event.clientX - bounds.left, 0, bounds.width);
  const yPosition = clamp(event.clientY - bounds.top, 0, bounds.height);
  const xPercent = (xPosition / bounds.width) * 100;
  const yPercent = (yPosition / bounds.height) * 100;

  image.style.transformOrigin = `${xPercent}% ${yPercent}%`;
}

function magnifyOnHover(image, zoomRatio) {
  const hoverArea = image.closest('.product__modal-opener--image') || image.closest('.product__media') || image;

  hoverArea.addEventListener('mouseenter', (event) => {
    moveZoom(image, hoverArea, event);
    image.style.transform = `scale(${zoomRatio})`;
  });

  hoverArea.addEventListener('mousemove', (event) => {
    moveZoom(image, hoverArea, event);
  });

  hoverArea.addEventListener('mouseleave', () => {
    image.style.transform = 'scale(1)';
    image.style.transformOrigin = 'center center';
  });
}

function enableZoomOnHover(zoomRatio) {
  if (!window.matchMedia('(hover: hover)').matches) return;

  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    if (image.dataset.zoomHoverBound === 'true') return;
    image.dataset.zoomHoverBound = 'true';
    magnifyOnHover(image, zoomRatio);
  });
}

enableZoomOnHover(1.8);
